import { AxiosInstance } from "axios";

const unwrapBody = (body) => (body?.data !== undefined ? body.data : body);

// Роуты admin-api на шлюзе отдаются под v3 (в OpenAPI-доке помечены как v1).
class ZonesApi {
    api: AxiosInstance;

    constructor(api) {
        this.api = api;
    }

    async list({ typeId, name, pageNumber, pageSize } = {}) {
        return await this.search({ typeId, name, pageNumber, pageSize });
    }

    async search({ typeId, name, lat, lng, oldZoneId, withGeometry, pageNumber, pageSize } = {}) {
        return await this.api.fetch({
            method: "post",
            url: `/admin/zones/search`,
            urlVersion: 3,
            data: {
                ...(name ? { name } : {}),
                ...(typeId != null ? { type_id: typeId } : {}),
                ...(lat != null && lng != null ? { lat, lng } : {}),
                ...(oldZoneId ? { old_zone_id: oldZoneId } : {}),
                ...(withGeometry ? { geometry: true } : {}),
                ...(pageNumber ? { page_number: pageNumber } : {}),
                ...(pageSize ? { page_size: pageSize } : {}),
            },
        });
    }

    async getById(id, { withGeometry = true } = {}) {
        return await this.api.fetch({
            method: "get",
            url: `/admin/zones/${id}`,
            urlVersion: 3,
            params: { ...(withGeometry ? { geometry: true } : {}), _: Date.now() }, // _ — обход кэша браузера
        });
    }

    // create → 201, remove → 204 без тела — поэтому returnBody и разворачивание ответа вручную.
    async create({ name, typeId, geometry, timezone, oldRegionId } = {}) {
        const body = await this.api.fetch({
            method: "post",
            url: `/admin/zones`,
            urlVersion: 3,
            data: {
                name,
                type_id: typeId,
                geometry,
                ...(timezone ? { timezone } : {}),
                ...(oldRegionId != null ? { old_region_id: oldRegionId } : {}),
            },
            returnBody: true,
        });
        return unwrapBody(body);
    }

    async regions({ name, cancelToken } = {}) {
        return await this.api.fetch({
            method: "get",
            url: `/admin/zones/regions`,
            urlVersion: 3,
            params: { ...(name ? { "filter[name]": name } : {}), page_size: 10, _: Date.now() },
            cancelToken,
            ignoreErrorMessage: true,
        });
    }

    async update(id, { name, geometry, timezone } = {}) {
        return await this.api.fetch({
            method: "put",
            url: `/admin/zones/${id}`,
            urlVersion: 3,
            data: {
                ...(name !== undefined ? { name } : {}),
                ...(geometry !== undefined ? { geometry } : {}),
                ...(timezone !== undefined ? { timezone } : {}),
            },
        });
    }

    async remove(id) {
        const body = await this.api.fetch({
            method: "delete",
            url: `/admin/zones/${id}`,
            urlVersion: 3,
            returnBody: true,
        });
        return unwrapBody(body);
    }
}

export default ZonesApi;
